import {api} from './api'

export const exportsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getReport: build.query<Blob, { reportType: string; dateRange: { start: string; end: string }; classId?: string | null; timestamp: number }>({
            query: ({ reportType, dateRange, classId, timestamp }) => {
                const { start, end } = dateRange;
                const filterBy = `created_at:">=${start}" created_at:"<=${end}"`;
                const params: any = { report_type: reportType, date_range: filterBy };
                if (classId) {
                    params.id = classId;
                }
                return {
                    url: `/reports`,
                    params,
                    responseHandler: async (response: any) => {
                        if (!response.ok) {
                            const error = await response.json();
                            throw new Error(error.message || 'Failed to fetch report');
                        }
                        return response.blob();
                    },
                };
            },
            providesTags: ['Reports'],
        }),
    }),
});

export const { useGetReportQuery } = exportsApi;
